module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-banner-rp.7996ec24.png";